import {StyledSpinner} from '@components/ui/spinner/style.ts'
import {SVGAttributes} from 'react'

interface SpinnerProps extends Omit<SVGAttributes<SVGSVGElement>, 'fill'> {
    fill?: string
    size?: number
    trackColor?: string
}

export const Spinner = ({
    size = 20,
    fill = 'currentColor',
    trackColor = 'rgba(0, 0, 0, 0.1)',
    ...rest
}: SpinnerProps) => (
    <StyledSpinner size={size} fill={fill} $trackColor={trackColor} viewBox="0 0 50 50" {...rest}>
        <circle className="track" cx="25" cy="25" r="20" fill="none" />
        <circle className="progress" cx="25" cy="25" r="20" fill="none" strokeDasharray="125" strokeDashoffset="50" />
    </StyledSpinner>
)

Spinner.displayName = 'Spinner'
